import React from 'react';
// import { SelectValidator } from 'react-material-ui-form-validator';
import { ValidatorComponent } from 'react-form-validator-core';

import SelectFieldRelative from '../../artzu-ui/src/SelectFieldRelative';
import Option from '../../artzu-ui/src/Option';

// import Option from 'material-ui/Option';

class NewDamageLocation extends ValidatorComponent {
  render() {
    const { title = '', onChange = () => {}, name = '' } = this.props;
    const { isValid } = this.state;

    return (
      <div className="">
        <SelectFieldRelative
          error={!isValid && this.getErrorMessage()}
          onChange={onChange}
          title={title}
          name={name}
          width="100%"
          style={{ 'font-size': '16px', 'padding-top': '10px' }}>
          <Option label="Driver Side" value="driver-side" />
          <Option label="Passenger Side" value="passenger-side" />
          <Option label="Front Bumper" value="front-bumper" />
          <Option label="Back Bumper" value="back-bumper" />
          <Option label="Headlights" value="headlights" />
          <Option label="Hood" value="hood" />
          <Option label="Trunk" value="trunk" />
          <Option label="Tires" value="tires" />
          <Option label="Windshield" value="windshield" />
          <Option label="Roof" value="roof" />
          <Option label="Underside" value="underside" />
          <Option label="Other" value="other" />
          <Option label="None" value="none" />
        </SelectFieldRelative>
      </div>
    );
  }
}

export default NewDamageLocation;



// WEBPACK FOOTER //
// ./src/components/Report/NewDamageLocation.js